import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const navItems = [
  { label: "首页", path: "/" },
  { label: "今日更新", path: "/updates" },
  { label: "漫画分类", path: "/comics" },
  { label: "关于我们", path: "/about" },
];

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (path: string) => {
    setMenuOpen(false);
    navigate(path);
  };

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const kw = keyword.trim();
    if (!kw) return;
    setMenuOpen(false);
    navigate(`/comics?q=${encodeURIComponent(kw)}`);
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur shadow-sm border-b border-background-200"
          : "bg-background-50 border-b border-background-200"
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 md:px-6">
        <button
          onClick={() => go("/")}
          className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-2-fill text-lg"></i>
          </span>
          <span className="font-heading text-xl font-extrabold text-foreground-950">
            笨狗漫画
            <span className="ml-1 text-primary-500">网</span>
          </span>
        </button>

        <div className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => {
            const active =
              item.path === "/"
                ? location.pathname === "/"
                : location.pathname.startsWith(item.path);
            return (
              <button
                key={item.path}
                onClick={() => go(item.path)}
                className={`rounded-full px-4 py-2 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  active
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {item.label}
              </button>
            );
          })}
        </div>

        <div className="hidden items-center gap-2 md:flex">
          <form
            onSubmit={handleSearch}
            className="flex items-center overflow-hidden rounded-full border border-background-300 bg-background-100 focus-within:border-primary-400 focus-within:ring-2 focus-within:ring-primary-100"
          >
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索漫画…"
              className="w-44 bg-transparent px-4 py-2 text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
            <button
              type="submit"
              aria-label="搜索"
              className="flex h-9 w-9 items-center justify-center text-foreground-600 hover:text-primary-600 cursor-pointer"
            >
              <i className="ri-search-line"></i>
            </button>
          </form>
        </div>

        <button
          onClick={() => setMenuOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-lg text-foreground-800 hover:bg-background-100 md:hidden cursor-pointer"
          aria-label="菜单"
        >
          <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
        </button>
      </nav>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 md:hidden">
          <div className="flex flex-col gap-1">
            {navItems.map((item) => {
              const active =
                item.path === "/"
                  ? location.pathname === "/"
                  : location.pathname.startsWith(item.path);
              return (
                <button
                  key={item.path}
                  onClick={() => go(item.path)}
                  className={`rounded-lg px-4 py-3 text-left text-sm font-medium whitespace-nowrap cursor-pointer ${
                    active
                      ? "bg-primary-500 text-background-50"
                      : "text-foreground-800 hover:bg-background-100"
                  }`}
                >
                  {item.label}
                </button>
              );
            })}
          </div>
          <form onSubmit={handleSearch} className="mt-3 flex items-center overflow-hidden rounded-full border border-background-300 bg-background-100">
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索漫画…"
              className="w-full bg-transparent px-4 py-2.5 text-sm text-foreground-900 outline-none"
            />
            <button
              type="submit"
              aria-label="搜索"
              className="flex h-10 w-10 items-center justify-center text-foreground-600 cursor-pointer"
            >
              <i className="ri-search-line"></i>
            </button>
          </form>
        </div>
      )}
    </header>
  );
}